export default __webpack_public_path__ + "static/media/dashboadIcon.3f9bccf4.svg";